import React, { useState } from "react";
import { useSelector } from "react-redux";

const FormInput = ({
  label,
  placeHolder,
  type,
  value,
  width = "",
  onchange,
  readOnly,
  disabled,
  icon,
  secIcon,
  name,
  step,
  onclick,
  secIconOnClick,
  iconOnClick,
}) => {
  const isDarkMode = useSelector((state) => state.appSettings?.appDarkMode);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const isPasswordField = type === "password";
  const inputType = isPasswordField
    ? passwordVisible
      ? "text"
      : "password"
    : type;

  const displayIcon =
    icon ?? (isPasswordField ? (passwordVisible ? "fa-eye-slash" : "fa-eye") : undefined);

  const handleIconClick =
    iconOnClick ??
    (isPasswordField
      ? (e) => {
          e.preventDefault();
          setPasswordVisible((prev) => !prev);
        }
      : undefined);

  const hasToggleIcon = Boolean(displayIcon);

  const customFormStyle = {
    borderRadius: "10px",
    border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
    background: isDarkMode ? "#2d3436" : "#F9F9F9",
    color: isDarkMode ? "#ffffff" : "#495057",
    height: "44px",
  };

  return (
    <>
      <label className="form-label">{label}</label>
      <div className="position-relative">
        <input
          type={inputType}
          value={value}
          readOnly={readOnly}
          disabled={disabled}
          onChange={onchange}
          onClick={onclick}
          step={step}
          name={name}
          className="form-control"
          placeholder={placeHolder}
          style={{
            ...customFormStyle,
            ...{ width: width },
            ...(hasToggleIcon && { paddingRight: secIcon ? "60px" : "40px" }),
          }}
        />
        {displayIcon && (
          <button
            type="button"
            onClick={handleIconClick}
            tabIndex={-1}
            aria-label={passwordVisible ? "Hide password" : "Show password"}
            style={{
              position: "absolute",
              right: secIcon ? "35px" : "12px",
              top: "50%",
              transform: "translateY(-50%)",
              border: "none",
              background: "transparent",
              padding: 0,
              color: isDarkMode ? "#adb5bd" : "#6c757d",
              cursor: "pointer",
              zIndex: 2,
            }}
          >
            <i className={`fa ${displayIcon}`} />
          </button>
        )}

        {secIcon && (
          <i
            className={`fa ${secIcon}`}
            onClick={secIconOnClick}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#f03a4f",
              cursor: "pointer",
            }}
          ></i>
        )}
      </div>
    </>
  );
};

export default FormInput;
